import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityEvryCourcouronnesPage() {
  const data = citiesData.find((c) => c.slug === "evry-courcouronnes")!;
  return <CityPage data={data} />;
}
